import { render, staticRenderFns } from "./VueGl.html?vue&type=template&id=6f5c8331&scoped=true&"
import script from "./VueGl.vue?vue&type=script&lang=js&"
export * from "./VueGl.vue?vue&type=script&lang=js&"
import style0 from "./VueGl.scss?vue&type=style&index=0&id=6f5c8331&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5c8331",
  null
  
)

export default component.exports